/* eslint-disable */
import React, { useCallback, useEffect, useState } from 'react'
import { Box, Container, Grid, IconButton, Button, Collapse, Avatar, Theme, Link } from '@mui/material'
import { makeStyles } from '@mui/styles'
import FavoriteIcon from '@mui/icons-material/Favorite'
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder'
import PlayArrowIcon from '@mui/icons-material/PlayArrow'
import clsx from 'clsx'
import { useNavigate } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { animateScroll as scroll } from 'react-scroll/modules'
import { AccessTime as AccessTimeIcon } from '@mui/icons-material'
import { formLocale, Layout, Loader, useWindowDimensions } from '../../components'
import { NewsVideoModal } from './news-video-modal'
import { ManagerModal } from './manager-modal'
import { img as imgs, img } from '../../imgs'
import { QuizModal } from './quiz'
import Slider, { Settings } from 'react-slick'
import { getMediaCupList, getMediaMarketList, getQuizMediaCup, votedMediaCup } from '../../api'
import { modalsAction } from '../../store/modals'
import { useReduxSelector } from '../../hooks'

const NextArrow = (props: any) => {
  const classes = useStyles()
  const { className, style, onClick } = props
  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" onClick={onClick} className={classes.btn}>
        <img src={imgs.next} alt="" height="100%" />
      </IconButton>
    </Box>
  )
}

const PrevArrow = (props: any) => {
  const classes = useStyles()
  const { className, style, onClick } = props
  return (
    <Box className={className} style={{ ...style }}>
      <IconButton color="primary" onClick={onClick} className={classes.btn}>
        <img src={imgs.prev} alt="" height="100%" />
      </IconButton>
    </Box>
  )
}

const LegendVideo: React.FC<{ className: any }> = ({ className }): JSX.Element => {
  const { REACT_APP_CDN_URL: URL } = process.env
  const [newsVideoModal, setNewsVideoModal] = useState<boolean>(false)
  
  return (
    <>
      <NewsVideoModal
        item={{
          type: 'VIDEO',
          src_video: [
            { src: `${URL}/legendmarket-1.mp4`, type: 'video/mp4' },
            { src: `${URL}/legendmarket-1.webm`, type: 'video/webm' },
          ],
        }}
        show={newsVideoModal}
        onClose={() => setNewsVideoModal(false)}
        className={className}
      />
      
      <Box className={className.legendVideoZoom} onClick={() => setNewsVideoModal(true)}>
        <Box id="play-container" className={className.legendVideo} />
        <Box position="absolute" top={0} left={0} className={className.legendPlayBox}>
          <Box id="play-btn" className={className.voteItemPlay}>
            <PlayArrowIcon />
          </Box>
        </Box>
      </Box>
    </>
  )
}

const GalaSlide: React.FC<{ className: any; item: any; indexPhoto: number; listPhoto: any[] }> = ({
  className,
  item,
  indexPhoto = 0,
  listPhoto = [],
}): JSX.Element => {
  const [newsVideoModal, setNewsVideoModal] = useState<boolean>(false)
  
  const { data: constants } = useReduxSelector((state) => state.constants)
  
  return (
    <Box>
      <NewsVideoModal
        item={item}
        indexSlide={indexPhoto}
        listPhoto={listPhoto}
        show={newsVideoModal}
        onClose={() => setNewsVideoModal(false)}
        className={className}
      />
      
      <Box className={className.galaPhotoZoom} onClick={() => setNewsVideoModal(true)}>
        <img id="play-container" src={item.src} alt="" className={className.galaPhoto} />
      </Box>
    </Box>
  )
}

const VoteItem: React.FC<{ item: any; className: any }> = ({ item = [], className }): JSX.Element => {
  const dispatch = useDispatch()

  const { serverError } = formLocale

  const [like, setLike] = useState<any>({
    voted: item.voted,
    num: item.vote,
  })
  const [newsVideoModal, setNewsVideoModal] = useState<boolean>(false)

  const onVoted = (id: number) => {
    votedMediaCup({ id })
      .then((res) => {
        if (res.status === 1) {
          setLike({ voted: true, num: like.num + 1 })
          dispatch(
            modalsAction.alert({
              message: { info: [`${res.message}`] },
              onClose: () => {},
            })
          )
        } else {
          dispatch(
            modalsAction.alert({
              message: { info: [`${res.message}`] },
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => {},
          })
        )
      })
  }

  return (
    <>
      <NewsVideoModal
        item={item}
        show={newsVideoModal}
        onClose={() => setNewsVideoModal(false)}
        className={className}
      />

      <Box className={className.voteItemZoom} onClick={() => setNewsVideoModal(true)}>
        <Box id="play-container" className={className.voteItemVideo} />
        <Box position="absolute" top={0} left={0} className={className.voteItemPlayBox}>
          <Box id="play-btn" className={className.voteItemPlay}>
            <PlayArrowIcon />
          </Box>
        </Box>
      </Box>
      <Grid container wrap="nowrap" justifyContent="flex-start" alignItems="center">
        <Grid item>
          <IconButton color="secondary" onClick={() => onVoted(item.id)}>
            {like.voted ? (
              <FavoriteIcon color="secondary" className={className.like} />
            ) : (
              <FavoriteBorderIcon color="secondary" className={className.like} />
            )}
          </IconButton>
        </Grid>
        <Grid item>
          <Box className={className.numLike}>{like.num}</Box>
        </Grid>
      </Grid>
      <Box className={className.voteItemText}>{item.name}</Box>
    </>
  )
}

const ManagerItem: React.FC<{ index: number; item: any; onOpenTopic: () => any; className: any }> = ({
  index = 0,
  item = [],
  className,
  onOpenTopic = () => {},
}): JSX.Element => {
  const { REACT_APP_URL: URL } = process.env
  
  const { data: constants } = useReduxSelector((state) => state.constants)

  const [show, setShow] = useState<boolean>(false)

  return (
    <>
      <ManagerModal item={item} show={show} onClose={() => setShow(false)} className={className} />

      <Grid container justifyContent="center">
        <Grid item>
          <Box
            width={174}
            height={153}
            display="flex"
            alignItems="flex-end"
            justifyContent="center"
            style={{ cursor: 'pointer' }}
            onClick={() => setShow(true)}
          >
            <img
              src={
                item.src
                  ? constants?.PROFILE === 'prod'
                    ? `${URL}${item.src}`
                    : `${URL}${item.src}`
                  : img.avatar
              }
              alt=""
              width="100%"
            />
          </Box>
        </Grid>
      </Grid>
      <Box className={className.managerItemName}>{item.name}</Box>
      <Box className={className.managerItemLink} onClick={onOpenTopic}>
        Посмотреть контент
      </Box>
    </>
  )
}

export const MediaPage: React.FC = (): JSX.Element => {
  const classes = useStyles()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  
  const settings: Settings = {
    speed: 300,
    dots: false,
    vertical: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    verticalSwiping: true,
  }
  
  const settingsGala: Settings = {
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: <NextArrow />,
    prevArrow: <PrevArrow />,
  }

  const { serverError } = formLocale

  const { width, height } = useWindowDimensions()

  const [more, setMore] = useState<boolean>(false)
  const [collapseHeight, setCollapseHeight] = useState<number>(230)

  const [mediaQuiz, setMediaQuiz] = useState<any>(undefined)
  const [mediaQuizLoad, setMediaQuizLoad] = useState<boolean>(true)
  const [mediaCup, setMediaCup] = useState<any>(undefined)
  const [mediaMarket, setMediaMarket] = useState<any>(undefined)
  const [photoGala, setPhotoGala] = useState<any[]>(Array(8))

  const onScrollTop = () => {
    scroll.scrollToTop()
  }

  const refs = () => {
    const vote1 = document.querySelector('#vote1') as HTMLElement
    const vote2 = document.querySelector('#vote2') as HTMLElement
    const vote3 = document.querySelector('#vote3') as HTMLElement
    const vote4 = document.querySelector('#vote4') as HTMLElement

    if (vote1 && vote2 && vote3 && vote4) {
      if (width > 1280) {
        setCollapseHeight(Math.max(vote1.scrollHeight, vote2.scrollHeight, vote3.scrollHeight, vote4.scrollHeight))
      } else if (width > 960 && width < 1280) {
        setCollapseHeight(Math.max(vote1.scrollHeight, vote2.scrollHeight, vote3.scrollHeight))
      } else if (width > 600 && width < 960) {
        setCollapseHeight(Math.max(vote1.scrollHeight, vote2.scrollHeight))
      } else if (width < 600) {
        setCollapseHeight(vote1.scrollHeight)
      }
    }
  }

  const loadMediaQuiz = useCallback(() => {
    getQuizMediaCup()
      .then((res) => {
        if (res.status === 1) {
          if (res.data.quiz) setMediaQuiz(res.data.quiz)
          else setMediaQuizLoad(false)
        } else {
          dispatch(
            modalsAction.alert({
              message: res.message,
              onClose: () => {
                setMediaQuizLoad(false)
              },
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => {
              setMediaQuizLoad(false)
            },
          })
        )
      })
  }, [])

  const loadMediaCupList = useCallback(() => {
    getMediaCupList()
      .then((res) => {
        if (res.status === 1) {
          setMediaCup(res.data.media)
        } else {
          dispatch(
            modalsAction.alert({
              message: res.message,
              onClose: () => {},
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => {},
          })
        )
      })
  }, [])

  const loadMediaMarketList = useCallback(() => {
    getMediaMarketList()
      .then((res) => {
        if (res.status === 1) {
          setMediaMarket(res.data.media)
        } else {
          dispatch(
            modalsAction.alert({
              message: res.message,
              onClose: () => navigate('../'),
            })
          )
        }
      })
      .catch(() => {
        dispatch(
          modalsAction.alert({
            message: serverError,
            onClose: () => navigate('../'),
          })
        )
      })
  }, [])
  
  const loadGalaPhoto = () => {
    const arr: { id: number; type: string; theme: string; src: string }[] = []
    for (let i = 1; i < 9; i++) {
      arr.push({
        id: i,
        type: 'PHOTO',
        theme: 'GALA',
        src: `https://cup.irb.rest/backend/static/news/gala/${i}.jpg`,
      })
    }
    setPhotoGala(arr)
  }

  useEffect(() => {
    // loadMediaQuiz()
    loadMediaCupList()
    loadMediaMarketList()
    loadGalaPhoto()
  }, [])

  return (
    <Layout>
      {/* {mediaQuiz && ( */}
      {/*  <QuizModal */}
      {/*    quiz={mediaQuiz} */}
      {/*    show={mediaQuiz} */}
      {/*    className={classes} */}
      {/*    onClose={() => { */}
      {/*      setMediaQuizLoad(false) */}
      {/*      setMediaQuiz(undefined) */}
      {/*    }} */}
      {/*  /> */}
      {/* )} */}

      <Box ref={refs} className={classes.page}>
        {mediaCup && mediaMarket && (
          <>
            <Container className={classes.container}>
              <Box className={classes.title}>Кубок в&nbsp;объективе</Box>
              <Box className={classes.subTitle}>ГАЛА-УЖИН ЛЕГЕНД IRB</Box>
              <Box className={classes.boxSliderGala}>
                <Grid container justifyContent="space-between" spacing={3}>
                    {/*<Slider {...settingsGala}>*/}
                    {photoGala.length > 0 &&
                      photoGala.map((i: any, k: number) => {
                        return (
                          <Grid item>
                            <GalaSlide className={classes} item={i} indexPhoto={k} listPhoto={photoGala} />
                          </Grid>
                        )
                      })}
                    {/*</Slider>*/}
                </Grid>
              </Box>
              <Grid container wrap="nowrap" justifyContent="center" alignItems="center">
                <Grid item width="100%">
                  <Box borderBottom="2px solid #6C6C6C" width="100%" />
                </Grid>
                <Grid item>
                  <Box
                    onClick={() => {
                      navigate('../gala')
                    }}
                    className={classes.moreBtn}
                  >
                    Посмотреть еще
                    <img
                      src={img.dropdown}
                      alt=""
                      className={clsx(classes.iconDropUp, { [classes.iconDropDown]: more })}
                    />
                  </Box>
                </Grid>
                <Grid item width="100%">
                  <Box borderBottom="2px solid #6C6C6C" width="100%" />
                </Grid>
              </Grid>
              <Box className={classes.subTitle}>Видеоконтест «СЕРДЦЕ&nbsp;КУБКА»</Box>
              <Box mb={{ xs: '20px', sm: '25px', md: '30px' }} textAlign={{ xs: 'center', sm: 'left' }}>
                <Link href="/backend/files/instruction_VideoContest.pdf" target="_blank" className={classes.link}>
                  Инструкция для участника видеоконтест СЕРДЦЕ КУБКА
                </Link>
              </Box>
              {collapseHeight && (
                <>
                  {mediaCup.length > 0 ? (
                    <Collapse in={more} collapsedSize={collapseHeight}>
                      <Grid container direction="row" justifyContent="space-evenly" alignItems="flex-start" spacing={3}>
                        {mediaCup &&
                          mediaCup.map((item: any, index: number) => {
                            return (
                              <Grid key={`${item.id}`} item>
                                <Box id={`vote${index + 1}`}>
                                  <VoteItem item={item} className={classes} />
                                </Box>
                              </Grid>
                            )
                          })}
                      </Grid>
                    </Collapse>
                  ) : (
                    <Grid container wrap="nowrap" spacing={2} className={classes.textBox}>
                      <Grid item>
                        <Box>
                          <AccessTimeIcon sx={{ fontSize: { xs: 34, sm: 40 } }} />
                        </Box>
                      </Grid>
                      <Grid item>
                        <Box className={classes.text}>
                          Здесь пишется история КУБКА 2023 твоего маркета: заливай свои фото, видео и репортажи!
                        </Box>
                      </Grid>
                    </Grid>
                  )}
                </>
              )}
              {mediaCup.length > 0 && (
                <Grid container wrap="nowrap" justifyContent="center" alignItems="center">
                  <Grid item width="100%">
                    <Box borderBottom="2px solid #6C6C6C" width="100%" />
                  </Grid>
                  <Grid item>
                    <Box
                      onClick={() => {
                        if (more) onScrollTop()
                        setMore(!more)
                      }}
                      className={classes.moreBtn}
                    >
                      {more ? 'Свернуть' : 'Смотреть больше'}
                      <img
                        src={img.dropdown}
                        alt=""
                        className={clsx(classes.iconDropUp, { [classes.iconDropDown]: more })}
                      />
                    </Box>
                  </Grid>
                  <Grid item width="100%">
                    <Box borderBottom="2px solid #6C6C6C" width="100%" />
                  </Grid>
                </Grid>
              )}

              <Box className={classes.subTitle}>ФОТО, ВИДЕО, РЕПОРТАЖИ</Box>
              <Box mb={{ xs: '30px', sm: '35px', md: '40px' }} textAlign={{ xs: 'center', sm: 'left' }}>
                <Link href="/backend/files/instruction_Cup_in_lense.pdf" target="_blank" className={classes.link}>
                  Инструкция для авторов КУБОК В ОБЪЕКТИВЕ
                </Link>
              </Box>
              <Grid container direction="row" justifyContent="space-evenly" alignItems="flex-start" spacing={3}>
                {mediaMarket &&
                  mediaMarket.map((item: any, index: number) => {
                    return (
                      <Grid id={`manager${item.id}`} item xs={12} sm={6} md={3}>
                        <ManagerItem
                          index={index}
                          item={item}
                          onOpenTopic={() => navigate(`../media/${item.id}?market`)}
                          className={classes}
                        />
                      </Grid>
                    )
                  })}
              </Grid>
            </Container>
            <img src={imgs.footerMedia} alt="" className={classes.mediaBottom} />
          </>
        )}
        {mediaQuizLoad && !mediaCup && !mediaMarket && (
          <Grid container justifyContent="center" alignItems="center" height="50vh">
            <Grid item>
              <Loader />
            </Grid>
          </Grid>
        )}
      </Box>
    </Layout>
  )
}

const useStyles = makeStyles(({ font, breakpoints: { down }, palette }: Theme) => ({
  page: {
    width: '100%',
    minHeight: 'calc(100vh - 190px)',
    padding: '50px 0 0',
    overflow: 'hidden',
    backgroundColor: '#131313',
    [down('md')]: {
      minHeight: 'calc(100vh - 230px)',
    },
    [down('sm')]: {
      minHeight: 'calc(100vh - 200px)',
      padding: '40px 0 0',
    },
  },
  container: {
    paddingBottom: '70px!important',
    [down('md')]: {
      padding: '0 10px 50px!important',
    },
  },
  title: {
    fontSize: 48,
    fontWeight: 700,
    color: palette.text.secondary,
    textTransform: 'uppercase',
    [down('lg')]: {
      fontSize: 44,
    },
    [down('md')]: {
      fontSize: 42,
    },
    [down('sm')]: {
      textAlign: 'center',
      fontSize: 32,
    },
  },
  link: {
    fontSize: '18px!important',
    fontWeight: 500,
    transition: '0.2s',
    [down('md')]: {
      fontSize: '16px!important',
    },
    [down('sm')]: {
      fontSize: '14px!important',
    },
  },
  subTitle: {
    fontSize: 28,
    fontWeight: 700,
    color: palette.text.primary,
    margin: '30px 0',
    [down('lg')]: {
      fontSize: 26,
    },
    [down('md')]: {
      fontSize: 24,
      margin: '25px 0px',
    },
    [down('sm')]: {
      fontSize: 20,
      textAlign: 'center',
      margin: '20px 0',
    },
  },
  voteItemZoom: {
    width: 280,
    height: 170,
    borderRadius: 6,
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    '-webkit-tap-highlight-color': 'transparent',
    background: 'linear-gradient(#7D0A13, #080102) 0 0 no-repeat',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
      '& #play-btn': {
        transform: 'scale(1.03)',
      },
    },
  },
  voteItemVideo: {
    width: 280,
    height: 170,
    display: 'flex',
    borderRadius: 6,
    transition: '0.3s',
    alignItems: 'center',
    backgroundSize: '200px 103px',
    justifyContent: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundImage: `url(${img.proKubok})`,
  },
  voteItemPlayBox: {
    width: 280,
    height: 170,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  voteItemPlay: {
    width: 55,
    height: 55,
    borderRadius: 30,
    display: 'flex',
    transition: '0.3s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '35px!important',
    },
  },
  voteItemPlayModal: {
    width: 70,
    height: 70,
    borderRadius: '50%',
    display: 'flex',
    transition: '0.2s',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'rgba(108, 108, 108, 0.8)',
    backdropFilter: 'blur(10px)',
    '& svg': {
      fill: '#ffffff!important',
      fontSize: '40px!important',
      [down('sm')]: {
        fontSize: '35px!important',
      },
    },
    [down('sm')]: {
      width: 55,
      height: 55,
    },
  },
  like: {
    fontSize: '25px!important',
  },
  numLike: {
    fontSize: 16,
    fontWeight: 500,
    [down('sm')]: {
      fontSize: 15,
    },
  },
  voteItemText: {
    width: 264,
    fontSize: 16,
    fontWeight: 500,
    padding: '0 8px',
    marginBottom: 15,
    [down('sm')]: {
      fontSize: 15,
    },
  },
  moreBtn: {
    fontSize: 16,
    fontWeight: 700,
    margin: '50px 0',
    color: '#6C6C6C',
    cursor: 'pointer',
    padding: '0 50px',
    userSelect: 'none',
    whiteSpace: 'nowrap',
    textTransform: 'uppercase',
    '-webkit-tap-highlight-color': 'transparent',
    [down('md')]: {
      padding: '0 40px',
    },
    [down('sm')]: {
      fontSize: 15,
      padding: '0 35px',
    },
  },
  iconDropUp: {
    width: 18,
    marginLeft: 15,
    [down('sm')]: {
      width: 16,
      marginLeft: 12,
    },
  },
  iconDropDown: {
    transform: 'rotate(180deg)',
  },
  managerItemName: {
    fontSize: 18,
    fontWeight: 600,
    margin: '20px 0',
    textAlign: 'center',
    [down('sm')]: {
      fontSize: 16,
      margin: '20px 0 15px',
    },
  },
  managerItemLink: {
    fontSize: 16,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'center',
    transition: '0.3s',
    textDecoration: 'underline',
    '-webkit-tap-highlight-color': 'transparent',
    marginBottom: 30,
    color: '#6C6C6C',
    '&:hover': {
      color: palette.text.secondary,
    },
    [down('sm')]: {
      fontSize: 15,
      marginBottom: 25,
    },
  },
  newsVideoBox: {
    maxWidth: 600,
    width: '100%',
    margin: '50px auto 30px',
    [down('sm')]: {
      maxWidth: 400,
    },
  },
  newsVideoBgImg: {
    maxWidth: 600,
    width: '100%',
    overflow: 'hidden',
    '& video': {
      borderRadius: 6,
    },
    [down('sm')]: {
      maxWidth: 400,
    },
  },
  newsVideoText: {
    fontSize: 18,
    width: '100%',
    maxWidth: 600,
    fontWeight: 500,
    margin: '0 auto',
    [down('sm')]: {
      fontSize: 16,
      maxWidth: 400,
    },
  },
  quiz: {
    '& .MuiFormControl-root': {
      width: '100%',
    },
    '& .MuiFormLabel-root': {
      fontWeight: 700,
      fontSize: 16,
      marginBottom: 20,
      '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, .4)!important',
      },
      [down('md')]: {
        fontSize: 15,
      },
      [down('sm')]: {
        fontSize: 14,
      },
    },
    '& .MuiFormControlLabel-root .MuiTypography-root': {
      fontWeight: 600,
      fontSize: '16px!important',
      '&.Mui-disabled': {
        color: 'rgba(255, 255, 255, .4)!important',
      },
      [down('md')]: {
        fontSize: '15px!important',
      },
      [down('sm')]: {
        fontSize: '14px!important',
      },
    },
  },
  iconCheck: {
    width: 11,
    height: 11,
    display: 'flex',
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
    border: `3px solid ${palette.primary.dark}`,
  },
  check: {
    borderRadius: 50,
    width: 11,
    height: 11,
    backgroundColor: ` ${palette.secondary.main}`,
  },
  mediaBottom: {
    width: '100%',
    minWidth: 1100,
  },
  btnQuiz: {
    padding: '10px 35px!important',
    fontSize: '16px!important',
  },
  managerTitleModal: {
    fontSize: 22,
    fontWeight: 700,
    marginTop: 30,
    [down('sm')]: {
      fontSize: 18,
      marginTop: 20,
    },
  },
  managerPositionModal: {
    fontSize: 19,
    fontWeight: 600,
    [down('sm')]: {
      fontSize: 16,
    },
  },
  managerBodyModal: {
    fontSize: 17,
    fontWeight: 500,
    margin: '20px 0 30px',
    textAlign: 'justify',
    hyphens: 'auto',
    [down('sm')]: {
      fontSize: 15,
      margin: '15px 0 20px',
      textAlign: 'center',
    },
  },
  managerLinkModal: {
    fontSize: 18,
    fontWeight: 500,
    cursor: 'pointer',
    textAlign: 'center',
    transition: '0.3s',
    textDecoration: 'underline',
    color: '#6C6C6C',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      color: palette.text.secondary,
    },
    [down('sm')]: {
      fontSize: 15,
    },
  },
  textBox: {
    margin: '50px 0 80px',
    '& svg': {
      fill: '#6C6C6C!important',
    },
    [down('sm')]: {
      margin: '50px 0 55px',
    },
  },
  text: {
    textAlign: 'left',
    fontSize: 17,
    lineHeight: 1.3,
    maxWidth: 500,
    color: '#6C6C6C',
    [down('md')]: {
      fontSize: 16,
    },
    [down('sm')]: {
      fontSize: 14,
    },
  },
  willChanges: {
    imageRendering: 'auto',
    willChange: 'transform',
    transform: 'translate3d(0, 0, 0)',
  },
  avatar: {
    color: '#222222!important',
  },
  btn: {
    width: 60,
    height: 60,
    [down('md')]: {
      width: 50,
      height: 50,
    },
  },
  boxSliderGala: {
    width: '100%',
    // marginBottom: 65,
    '& .slick-list': {
      width: '92%',
      position: 'relative',
      left: '4%',
    },
    '& .slick-slide': {},
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    '& .slick-next': {
      top: '55%',
      right: -35,
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    '& .slick-prev': {
      top: '55%',
      left: -15,
      width: '80px!important',
      height: '80px!important',
      [down('md')]: {
        width: '70px!important',
        height: '70px!important',
      },
    },
    [down('md')]: {
      marginBottom: 55,
    },
    [down('sm')]: {
      marginBottom: 45,
    },
  },
  galaPhotoZoom: {
    width: 265,
    height: 160,
    borderRadius: 6,
    display: 'flex',
    cursor: 'pointer',
    overflow: 'hidden',
    position: 'relative',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0px auto',
    '-webkit-tap-highlight-color': 'transparent',
    '&:hover': {
      '& #play-container': {
        transform: 'scale(1.03)',
      },
    },
    [down('md')]: {
      width: 280,
      height: 170,
    },
  },
  galaPhoto: {
    width: 265,
    minHeight: 160,
    borderRadius: 6,
    transition: '0.3s',
    [down('md')]: {
      width: 280,
      minHeight: 170,
    },
  },
  imgModal: {
    width: '100%',
    borderRadius: 6,
  },
  titleModal: {
    fontSize: 20,
    fontWeight: 700,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    textTransform: 'uppercase',
    margin: '20px 0',
    [down('sm')]: {
      fontSize: 18,
      paddingLeft: 10,
      paddingRight: 10,
      margin: '15px 0',
    },
  },
  textModal: {
    fontSize: 15,
    fontWeight: 500,
    textAlign: 'center',
    paddingLeft: 20,
    paddingRight: 20,
    lineHeight: 1.4,
    [down('sm')]: {
      fontSize: 14,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  textPhotoModal: {
    fontSize: 16,
    fontWeight: 500,
    lineHeight: 1.4,
    marginTop: 30,
    [down('sm')]: {
      fontSize: 15,
      paddingLeft: 10,
      paddingRight: 10,
    },
  },
  boxSlider: {
    width: '100%',
    margin: '0 auto',
    '& .slick-list': {
      width: '90%',
      position: 'relative',
      left: '5%',
    },
    '& .slick-slide': {},
    '& .slick-next:before, .slick-prev:before': {
      content: 'none',
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-next': {
      width: '60px!important',
      height: '60px!important',
      right: -15,
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
    '& .slick-prev': {
      left: -15,
      width: '60px!important',
      height: '60px!important',
      [down('sm')]: {
        width: '50px!important',
        height: '50px!important',
      },
    },
  },
}))
